<template>
	<el-row>
		<el-row>
			<div style="display: flex;">
				<el-form label-width="100px" label-postion="right">
					<el-form-item label="一级分类:">
						{{ info2.primaryName }}
						<span style="padding-left: 50px;">二级分类:{{ info2.secondaryName }}</span>
					</el-form-item>
					<el-form-item label="商品款式:">
						{{ info2.commodityName }}
					</el-form-item>
					<el-form-item label="商品id:">
						{{ info2.commodityId }}
					</el-form-item>
					<el-form-item label="商品主图:">
						<el-image :src="info2.commodityPic" style="width: 100px;height: 100px;"></el-image>
					</el-form-item>
					<el-form-item label="销售人群:">
						{{ info2.labelName }}
					</el-form-item>
				</el-form>
			</div>
		</el-row>
		<el-row>
			<el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect"
				style="background-color: #f2f2f2;height: 50px;">
				<el-menu-item index="07">成品素材</el-menu-item>
				<el-menu-item index="08">优秀圈文</el-menu-item>
				<el-menu-item index="09">用户反馈</el-menu-item>
				<el-menu-item index="10">核心卖点</el-menu-item>
				<el-menu-item index="15">散珠素材</el-menu-item>
			</el-menu>
			<div style="width: 100%;height: auto;background-color: #f5f5f5;">
				<template v-if="materialPicVos.length > 0">
					<div style="width: 100%; height: auto" v-for="(item, index) in materialPicVos" :key="index">
						<div style="width: 20%;height: 50px;text-align: center;line-height: 50px;margin: 0 auto;;background-color: rgba(218, 218, 218,0.9);
															color: #fdfffd;">
							{{ item.createTime }}
						</div>
						<div style="display: flex;margin-top: 20px;">
							<div style="width: 80px; height: 80px;">
								<img :src="tx" width="100%" height="100%" />
							</div>
							<div style="margin-left: 20px">
								<template v-if="item.materialType == '02'">
									<div style="height: 50px; line-height: 50px">
										{{ typeName }}--- 商品主图
									</div>
									<div style="height: 50px; line-height: 50px" v-if="activeIndex == '15'">
										sku---{{ item.displayName ? item.displayName : '无' }}
									</div>
									<el-upload :class="{ hide: true }" action="" :file-list="item.imgUrl"
										list-type="picture-card" :disabled="true"></el-upload>
								</template>
								<template v-if="item.materialType == '03'">
									<div style="height: 50px; line-height: 50px">
										{{ typeName }}--- 海报
									</div>
									<div style="height: 50px; line-height: 50px" v-if="activeIndex == '15'">
										sku---{{ item.displayName ? item.displayName : '无' }}
									</div>
									<el-image :src="item.url" style="height: 200px"></el-image>
									<div>
										海报描述：{{ item.description ? item.description : '无' }}
									</div>
								</template>
								<template v-if="item.materialType == '04'">
									<div style="height: 50px; line-height: 50px">
										{{ typeName }}--- 视频
									</div>
									<div style="height: 50px; line-height: 50px" v-if="activeIndex == '15'">
										sku---{{ item.displayName ? item.displayName : '无' }}
									</div>
									<video width="300px" height="200px" :src="item.url" controls></video>
								</template>
							</div>
						</div>
						<div style="text-align: center;width: 100%;:">
							<el-button @click="delList(item)" type="text" icon="el-icon-delete" style="color: #df3b54;">
								删除</el-button>
							<el-button @click="editorList(item)" type="text" icon="el-icon-circle-plus-outline">
								编辑
							</el-button>
						</div>
					</div>
				</template>
				<template v-if="paragraphVos.length > 0">
					<div style="width: 100%; height: auto" v-for="(item, index) in paragraphVos" :key="index">
						<div style="width: 20%;height: 50px;text-align: center;line-height: 50px;background-color: rgba(218, 218, 218,0.9);
																			color: #fdfffd;margin: 0 auto;">
							{{ item.createTime }}
						</div>
						<div style="display: flex;margin-top: 20px;">
							<div style="width: 80px; height: 80px;">
								<img :src="tx" width="100%" height="100%" />
							</div>
							<div style="margin-left: 10px">
								<template v-if="item.paragraphType == '01'">
									<div style="height: 50px; line-height: 50px">
										{{ typeName }} --- 内容段落
									</div>
									<div style="height: 50px; line-height: 50px" v-if="activeIndex == '15'">
										sku---{{ item.displayName ? item.displayName : '无' }}
									</div>
									<el-form label-position="right" label-width="100px" style="margin-top: 10px">
										<el-form-item label="内容标题:">{{ item.title }}</el-form-item>
										<div v-for="(item2, index2) in item.paragraph2">
											<el-form-item>{{ item2 }}</el-form-item>
										</div>
									</el-form>
								</template>
								<template v-if="item.paragraphType == '02'">
									<div style="height: 50px; line-height: 50px">
										{{ typeName }} --- 富文本
									</div>
									<div style="height: 50px; line-height: 50px" v-if="activeIndex == '15'">
										sku---{{ item.displayName ? item.displayName : '无' }}
									</div>
									<div style="margin-top: 10px">
										<div v-html="item.paragraph"></div>
										<!-- <wangeditor v-model="item.paragraph"></wangeditor> -->
									</div>
								</template>
								<template v-if="item.paragraphType == '03'">
									<div style="height: 50px; line-height: 50px">
										{{ typeName }} --- 圈文
									</div>
									<div style="height: 50px; line-height: 50px" v-if="activeIndex == '15'">
										sku---{{ item.displayName ? item.displayName : '无' }}
									</div>
									<p>{{ item.paragraph }}</p>
									<template v-if="item.type2 == 0">
										<el-upload :class="{ hide: true }" action="" :file-list="item.imgUrl"
											list-type="picture-card" :disabled="true"></el-upload>
									</template>
									<template v-if="item.type2 == 1">
										<video width="300px" height="200px" :src="item.paragraphUrl" controls></video>
									</template>
								</template>
							</div>
						</div>
						<div style="text-align: center;width: 100%;:">
							<el-button @click="delList(item)" type="text" icon="el-icon-delete" style="color: #df3b54;">
								删除</el-button>
							<el-button @click="editorList(item)" type="text" icon="el-icon-circle-plus-outline">
								编辑
							</el-button>
						</div>
					</div>
				</template>
				<template v-if="festivalCommodityVos.length > 0">
					<div style="width: 100%; height: auto" v-for="(item, index) in festivalCommodityVos" :key="index">
						<div style="width: 20%;height: 50px;text-align: center;line-height: 50px;background-color: rgba(218, 218, 218,0.9);
																		color: #fdfffd;margin: 0 auto;">
							{{ item.createTime }}
						</div>
						<div style="display: flex;margin-top: 20px;">
							<div style="width: 80px; height: 80px;">
								<img :src="tx" width="100%" height="100%" />
							</div>
							<div style="margin-left: 10px;margin-top: 20px;">
								<div style="height: 50px; line-height: 50px">
									{{ typeName }}--- 节日款商品
								</div>
								<div style="height: 50px; line-height: 50px" v-if="activeIndex == '15'">
									sku---{{ item.displayName }}
								</div>
								<el-form label-position="right" label-width="100px" style="width: 700px">
									<el-form-item label="商品ID">{{ item.commodityId }}</el-form-item>
									<el-form-item label="商品图片">
										<img :src="item.commodityPic" height="200px" />
									</el-form-item>
									<el-form-item label="商品标题">{{ item.commodityTitle }}</el-form-item>
									<el-form-item label="商品售价">{{ item.commodityPrices }}</el-form-item>
								</el-form>
							</div>
						</div>
						<div style="text-align: center;width: 100%;:">
							<el-button @click="delList(item)" type="text" icon="el-icon-delete" style="color: #df3b54;">
								删除
							</el-button>
							<el-button @click="editorList(item)" type="text" icon="el-icon-circle-plus-outline">
								编辑
							</el-button>
						</div>
					</div>
				</template>
				<template v-if="chatScriptVos.length > 0">
					<div style="width: 100%; height: auto" v-for="(item, index) in chatScriptVos" :key="index">
						<div
							style="width: 20%;height: 50px;text-align: center;line-height: 50px;background-color: rgba(218, 218, 218,0.9);												color: #fdfffd;margin: 0 auto;">
							{{ item[0].createTime }}
						</div>
						<div style="display: flex;margin-top: 20px;">
							<div style="width: 80px; height: 80px;">
								<img :src="tx" width="100%" height="100%" />
							</div>
							<div style="margin-left: 10px">
								<div style="height: 50px; line-height: 50px">
									{{ typeName }} --- 聊天话术
								</div>
								<div style="height: 50px; line-height: 50px" v-if="activeIndex == '15'">
									sku---{{ item[0].displayName }}
								</div>
								<div v-for="(item2, index2) in item" style="width: 700px; background-color: #fff">
									<div v-if="item2.chatType == '01'"
										style="width: 100%;display: flex;align-items: center;justify-content: flex-start;">
										<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/05.png"
											width="90px" height="90px" />
										{{ item2.chatContent }}
									</div>
									<div v-if="item2.chatType == '02'"
										style="width: 100%;display: flex;align-items: center;justify-content: flex-end;">
										{{ item2.chatContent }}
										<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/03.png"
											width="90px" height="90px" />
									</div>
								</div>
							</div>
						</div>
						<div style="text-align: center;width: 100%;:">
							<el-button @click="delList(item)" type="text" icon="el-icon-delete" style="color: #df3b54;">
								删除</el-button>
							<el-button @click="editorList(item)" type="text" icon="el-icon-circle-plus-outline">
								编辑
							</el-button>
						</div>
					</div>
				</template>
				<el-button class="add" type="danger" @click="addList">
					添加+
				</el-button>
			</div>
		</el-row>
		<el-dialog :visible.sync="dialogVisible" :title="title" center>
			<el-form ref="info" :model="info" :rules="infoRules" label-position="right" label-width="110px">
				<el-form-item label="选择sku" v-if="activeIndex == '15'">
					<el-select v-model="skuList">
						<el-option v-for="item in Skuoptions" :key="item.value" :label="item.label" :value="item">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="素材类型">
					<el-tag :class="chooseType == item.value ? 'tag2' : 'tag'" v-for="(item, index) in typeList"
						:key="index" @click="choose(item)" :style="title == '编辑发布信息' ? 'pointer-events: none' : ''">
						{{ item.label }}
					</el-tag>
				</el-form-item>
				<template v-if="chooseType == 1">
					<el-form-item label="上传主图" prop="url1">
						<el-radio-group v-model="radioValue" @input="chooseRadio(1)">
							<el-radio :label="0">本地上传</el-radio>
							<el-radio :label="1">图片库上传</el-radio>
						</el-radio-group>
						<el-upload :class="{ hide: hideUpload }" :action="action" list-type="picture-card" :limit="1"
							:on-success="getPictrueURL" accept=".jpg,.png" :file-list="fileList"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed"
							:append-to-body="true">
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<span>png/jpg格式，限一张</span>

					</el-form-item>
					<el-form-item label="海报描述" prop="description">
						<el-input type="textarea" v-model="info.description" maxlength="100" show-word-limit></el-input>
					</el-form-item>
				</template>
				<template v-if="chooseType == 2">
					<el-form-item label="上传视频" prop="video2">
						<el-upload :action="action" list-type="picture-card" :limit="1" :on-success="getPictrueURL"
							accept=".mp4" v-if="info.video2 == ''">
							<i class="el-icon-plus" />
						</el-upload>
						<div style="display: flex" v-if="info.video2 != ''">
							<video :src="info.video2" width="500px" height="300px" controls></video>
							<div style="display: flex; align-items: center">
								<el-button type="text" icon="el-icon-delete-solid" @click="handleRemove()"></el-button>
							</div>
						</div>
						<span>mp4格式，限一条</span>
					</el-form-item>
				</template>
				<template v-if="chooseType == 3">
					<el-form-item label="内容信息" prop="title3">
						<el-input type="textarea" v-model="info.title3" maxlength="5000" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="上传类型:">
						<el-select v-model="value" @change="chooseValue">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="value == 0" prop="url3">
						<!-- <el-radio-group v-model="radioValue" @input="chooseRadio(9)">
							<el-radio :label="0">本地上传</el-radio>
							<el-radio :label="1">图片库上传</el-radio>
						</el-radio-group> -->
						<el-button @click="openImg(9)" type="primary" v-if="fileList.length<9">图片库上传</el-button>
						<el-upload :class="{ hide: true }" :action="action" list-type="picture-card"
							:file-list="fileList" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
							v-if="fileList.length>0">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed"
							:append-to-body="true">
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<span>png/jpg格式，限9张</span>
					</el-form-item>
					<el-form-item v-if="value == 1" prop="video3">
						<el-upload :class="{ hide: hideUpload }" :action="action" list-type="picture-card"
							:on-success="getPictrueURL" accept=".mp4" v-if="info.video3 == ''">
							<i class="el-icon-plus" />
						</el-upload>
						<div style="display: flex" v-if="info.video3 != ''">
							<video width="60%" :src="info.video3" controls></video>
							<div style="display: flex; align-items: center; margin-left: 10px">
								<el-button icon="el-icon-delete" @click="handleRemove()" size="small" type="primary">
								</el-button>
							</div>
						</div>
						<span>mp4格式，限1条</span>
					</el-form-item>
				</template>
				<template v-if="chooseType == 4">
					<div v-for="(item, index) in info.arr4">
						<el-form-item label="商品主图" :prop="`arr4.${index}.commodityPic`" :rules="[{
							required: true, message: '请上传商品主图', trigger: 'blur',
						}]">
							<div>
								<div>
									<el-upload :class="{ hide: hideUpload }" :action="action" list-type="picture-card"
										:limit="1" :on-success="getPictrueURL2.bind(null, { index: index, data: item })"
										accept=".jpg,.png" :file-list="info.arr4[index].commodityPic"
										:on-remove="handleRemove2.bind(null, { index: index, data: item })"
										v-if="info.arr4[index].commodityPic.length == 0">
										<i class="el-icon-plus" />
									</el-upload>
									<div style="display: flex; align-items: center"
										v-if="info.arr4[index].commodityPic.length > 0">
										<el-image style="width: 150px; height: 150px"
											:src="info.arr4[index].commodityPic[0].url"></el-image>
										<div style="margin-left: 20px">
											<el-button icon="el-icon-delete" size="small" @click="delCon(index, '4s')"
												type="primary">
											</el-button>
										</div>
									</div>
									<span>png/jpg格式，限一张</span>
								</div>
								<div style="display: flex;align-items: center;margin-left: 10px;">
									<el-button @click="openImg(1)" type="text">图片库上传</el-button>
								</div>
							</div>
						</el-form-item>
						<el-form-item label="商品标题" :prop="`arr4.${index}.commodityTitle`" :rules="[{
							required: true, message: '请输入商品标题', trigger: 'blur'
						}]">
							<el-input type="textarea" maxlength="50" show-word-limit v-model="item.commodityTitle">
							</el-input>
						</el-form-item>
						<el-form-item label="商品售价" :prop="`arr4.${index}.commodityPrices`" :rules="[{
							required: true, message: '请输入商品售价', trigger: 'blur',
						},
						{ min: 0, max: 10, message: '长度在10位数以内', trigger: 'blur' }]">
							<el-input maxlength="200" show-word-limit v-model="item.commodityPrices" type="number">
							</el-input>
						</el-form-item>
						<el-form-item label="商品id" :prop="`arr4.${index}.commodityId`" :rules="[{
							required: true, message: '请输入商品id', trigger: 'blur',
						},]">
							<el-input v-model="item.commodityId"> </el-input>
						</el-form-item>
						<el-form-item v-if="isShow2">
							<el-button @click="delCon(index, 4)" icon="el-icon-delete" type="text"
								v-if="info.arr4.length > 1">
							</el-button>
							<div v-if="addIshow">
								<el-button @click="addCon(4)" type="text" v-if="index == info.arr4.length - 1">
									再加一个商品
								</el-button>
							</div>
						</el-form-item>
					</div>
				</template>
				<template v-if="chooseType == 6">
					<el-form-item label="上传主图" prop="url6">
						<el-radio-group v-model="radioValue" @input="chooseRadio(9)">
							<el-radio :label="0">本地上传</el-radio>
							<el-radio :label="1">图片库上传</el-radio>
						</el-radio-group>
						<el-upload :class="{ hide: hideUpload }" :action="action" list-type="picture-card" :limit="9"
							:on-success="getPictrueURL" accept=".jpg,.png" :file-list="fileList"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :multiple="true">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed"
							:append-to-body="true">
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<span>png/jpg格式，限九张</span>
					</el-form-item>
				</template>
				<template v-if="chooseType == 7">
					<el-form-item label="内容标题" prop="title7">
						<el-input show-word-limit maxlength="50" v-model="info.title7"></el-input>
					</el-form-item>
					<div v-for="(item, index) in info.arr7">
						<el-form-item label="内容段落" :prop="`arr7.${index}.paragraph7`" :rules="[{
							required: true, message: '请输入内容段落', trigger: 'blur'
						}]">
							<el-input type="textarea" v-model="item.paragraph7" show-word-limit maxlength="5000">
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button @click="delCon(index, 6)" icon="el-icon-delete" type="text"
								v-if="info.arr7.length > 1">
							</el-button>
							<el-button @click="addCon(6)" type="text" v-if="index == info.arr7.length - 1">再来一段
							</el-button>
						</el-form-item>
					</div>
				</template>
				<template v-if="chooseType == 8">
					<el-form-item label="富文本" prop="title8">
						<wangeditor v-model="info.title8"></wangeditor>
					</el-form-item>
				</template>
				<template v-if="chooseType == 9">
					<div style="width: 80%; height: 100%; margin: 0 auto" v-for="(item, index) in info.arr9"
						:key="index">
						<div v-if="item.chatType == '01'"
							style="display: flex;align-items: center;justify-content: flex-start;">
							<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/05.png"
								width="90px" height="90px" />
							<el-input v-model="item.chatContent" style="width: 550px"></el-input>
							<el-button @click="del(item, index)" icon="el-icon-delete-solid" type="text"></el-button>
						</div>
						<div v-if="item.chatType == '02'"
							style="display: flex;align-items: center;justify-content: flex-end;">
							<el-button @click="del(item, index)" icon="el-icon-delete" type="text"></el-button>
							<el-input v-model="item.chatContent" style="width: 550px"></el-input>
							<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/06.png"
								width="90px" height="90px" />
						</div>
					</div>
					<div style="width: 80%;height: 100%;margin: 0 auto;display: flex;justify-content: space-between;">
						<el-button @click="add(1)" type="text"> 左面加一条</el-button>
						<el-button @click="add(2)" type="text"> 右面加一条</el-button>
					</div>
				</template>
				<el-form-item>
					<el-button type="infor" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="sumbit()">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-drawer title="选择图片" :visible.sync="isSelectPicture" direction="rtl" size="40%">
			<SelectPicture :imgNum="imgNum" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>

<script>
	import wangeditor from "../../../components/wangEditor/wangEditor.vue";
	import httpClient from '../../../util/request.js';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			wangeditor,
			SelectPicture
		},
		data() {
			return {
				radioValue: 0,
				isSelectPicture: false,
				imgNum: 0,
				skuList: {},
				info2: {
					primaryName: '',
					secondaryName: '',
					commodityName: "",
					commodityId: '',
					commodityPic: '',
					labelName: ''
				},
				activeIndex: '07',
				typeName: "成品素材",
				isEditor: true,
				disabled: true,
				tx: "https://xinian.oss-cn-beijing.aliyuncs.com/picture/20220422jksdhvjukdsghvjhkdsbvhijkdsghvuidshvuidshvb%20iudjks.jpg",
				list: [],
				labelIds: [],
				addIshow: true,
				options2: [],
				action: httpClient.imgUrl,
				dialogVisible: false,
				chatScriptVos: [], //聊天话术表
				festivalCommodityVos: [], //节日款商品表
				materialPicVos: [], //图片\视频 链接
				paragraphVos: [], //圈文\内容段落\富文本 内容表
				title: "",
				info: {
					id: "",
					chatRecords: "",
					url1: "",
					description: '',
					video2: "",
					url6: "",
					title3: "",
					url3: "",
					video3: "",
					title8: "",
					title7: "",
					arr7: [{
						paragraph7: "",
					}, ],
					arr4: [{
						commodityPic: [],
						commodityTitle: "",
						commodityPrices: null,
						commodityId: "",
					}, ],
					arr9: [],
				},
				infoRules: {
					description: [{
						required: true,
						message: "请输入海报描述",
						trigger: "change",
					}],
					url1: [{
						required: true,
						message: "请上传主图",
						trigger: "change",
					}, ],
					video2: [{
						required: true,
						message: "请上传视频",
						trigger: "change",
					}, ],
					url6: [{
						required: true,
						message: "请上传商品主图",
						trigger: "change",
					}, ],
					url3: [{
						required: true,
						message: "请上传文件",
						trigger: "change",
					}, ],
					title3: [{
						required: true,
						message: "请输入内容信息",
						trigger: "change",
					}, ],
					url3: [{
						required: true,
						message: "请上传图片",
						trigger: "change",
					}, ],
					video3: [{
						required: true,
						message: "请上传视频",
						trigger: "change",
					}, ],
					title8: [{
						required: true,
						message: "请输入富文本",
						trigger: "change",
					}, ],
					title7: [{
						required: true,
						message: "请输入内容标题",
						trigger: "change",
					}, ],
				},
				chooseType: 1,
				hideUpload: false,
				fileList: [],
				dialogImageUrl: "",
				dialogDisplay: false,
				value: 0,
				Skuoptions: [],
				options: [{
						value: 0,
						label: "图片",
					},
					{
						value: 1,
						label: "视频",
					},
				],
				props: {
					value: "id",
					label: "name",
					children: "sonList",
					multiple: true,
				},
				typeList: [
					// {
					// 	value: 1,
					// 	label: "海报",
					// },
					{
						value: 2,
						label: "视频",
					},
					{
						value: 3,
						label: "圈文",
					},
					// {
					// 	value: 4,
					// 	label: "节日款商品",
					// },
					// {
					// 	value: 5,
					// 	label: "节日活动",
					// },
					// {
					// 	value: 6,
					// 	label: "商品主图",
					// },
					{
						value: 7,
						label: "内容段落",
					},
					// {
					// 	value: 8,
					// 	label: "富文本",
					// },
					{
						value: 9,
						label: "聊天话术",
					},
				],
				isShow2: true
			}
		},
		methods: {
			chooseRadio(num) {
				if (this.radioValue == 1) {
					this.isSelectPicture = true
					this.imgNum = num
				}
			},
			openImg(num) {
				this.imgNum = num
				this.isSelectPicture = true
			},
			getImg(e) {
				console.log(e);
				this.fileList = []
				e.split(',').forEach(item => {
					this.fileList.push({
						url: item
					})
				})
				if (this.chooseType == 1) {
					this.info.url1 = e
				}
				if (this.chooseType == 3) {
					this.info.url3 = e
				}
				if (this.chooseType == 6) {
					this.info.url6 = e
				}
				this.isSelectPicture = false
			},
			handleSelect(key, keyPath) {
				this.activeIndex = keyPath[0];
				this.getList(keyPath[0]);
				this.getInfo()
				switch (keyPath[0]) {
					case "07": {
						this.typeName = "成品素材";
						break;
					}
					case "08": {
						this.typeName = "优秀圈文";
						break;
					}
					case "09": {
						this.typeName = "用户反馈";
						break;
					}
					case "10": {
						this.typeName = "核心卖点";
						break;
					}
					case "11": {
						this.typeName = "销售人群";
						break;
					}

					case "15": {
						this.typeName = "散珠素材";
						break;
					}

					case "06": {
						this.typeName = "品类推广文案";
						break;
					}
				}
			},
			editor() {
				this.isEditor = !this.isEditor
				console.log(this.isEditor);
				if (this.isEditor) {
					this.$confirm('此操作将改变销售人群, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let labelIds = []
						if (this.labelIds.length > 0) {
							this.labelIds.forEach(i => {
								labelIds.push(i[1])
							})
						}
						console.log(labelIds);
						this.$http.post('/api/plant/knowledgeBase/updateKnowledgeBase', {
							"id": this.$route.query.id,
							"labelIds": labelIds,
						}).then(res => {
							if (res.data.status == 0) {
								this.getInfo()
								this.getList("01")
								this.$message({
									type: 'success',
									message: '修改成功!'
								});
							} else {
								this.$message({
									type: 'info',
									message: '修改失败'
								});
							}
						})

					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				} else {
					this.disabled = false
				}
			},
			sumbit() {
				console.log(this.skuList);
				console.log(this.info);
				if (this.activeIndex == '15') {
					// if (Object.keys(this.skuList).length === 0) {
					// 	this.$message.error('请选择sku')
					// 	return false
					// }
				}
				this.$refs.info.validate((val) => {
					if (val) {
						let url = "";
						let materialType = "";
						let paragraphType = "";
						let title = "";
						let paragraph = "";
						let kinds = "";
						kinds = this.activeIndex;
						switch (this.chooseType) {
							case 1: {
								console.log(this.info.url1);
								url = this.info.url1;
								materialType = "03";
								break;
							}
							case 2: {
								url = this.info.video2;
								materialType = "04";
								break;
							}
							case 3: {
								if (this.info.video3) {
									url = this.info.video3;
								} else {
									url = this.info.url3;
								}
								paragraph = this.info.title3;
								paragraphType = "03";
								break;
							}
							case 4: {
								if (this.title == "请输入发布信息") {
									this.info.arr4.forEach((i) => {
										i.commodityPic = i.commodityPic[0].url;
										i.parentId = this.$route.query.id;
										i.kinds = kinds
										i.commodityModel = "03"
										i.skuCode = this.skuList.value //sku编号
										i.displayName = this.skuList.label //当sku作为属性值出现时的显示名称
									});
									this.$http.post("/api/plant/knowledgeBase/insertFestCommodity", this.info.arr4)
										.then((res) => {
											console.log(res);
											if (res.data.status == 0) {
												this.$message.success("添加成功");
												this.dialogVisible = false;
												this.activeIndex = kinds;
												this.getList(kinds);
												this.getInfo()
											} else {
												this.$message.error(res.data.msg);
											}
										});
								} else {
									this.info.arr4.forEach((i) => {
										i.commodityPic = i.commodityPic[0].url;
										i.parentId = this.$route.query.id;
										i.kinds = kinds;
										i.id = this.info.id;
										i.commodityModel = "03";
										i.skuCode = this.skuList.value, //sku编号
											i.displayName = this.skuList.label //当sku作为属性值出现时的显示名称
									});
									console.log(this.info.arr4);
									this.$http
										.post(
											"/api/plant/knowledgeBase/updateFestCommodity",
											this.info.arr4[0]
										)
										.then((res) => {
											console.log(res);
											if (res.data.status == 0) {
												this.$message.success("修改成功");
												this.dialogVisible = false;
												this.activeIndex = kinds;
												this.getList(kinds);
												this.getInfo()
											} else {
												this.$message.error(res.data.msg);
											}
										});
								}
								break;
							}

							case 6: {
								url = this.info.url6;
								materialType = "02";
								break;
							}
							case 7: {
								let arr = [];
								this.info.arr7.forEach((i) => {
									arr.push(i.paragraph7);
								});
								paragraph = arr.join("&");
								title = this.info.title7;
								paragraphType = "01";
								break;
							}
							case 8: {
								paragraph = this.info.title8;
								paragraphType = "02";
								break;
							}
							case 9: {
								for (var i = 0; i < this.info.arr9.length; i++) {
									if (this.info.arr9[i].chatContent == "") {
										this.$message.error("聊天话术未填写完整");
										return false;
									}
								}
								console.log(this.info.arr9);
								if (this.title == "请输入发布信息") {
									this.info.arr9.forEach((i, n) => {
										i.parentId = this.$route.query.id - 0;
										i.kinds = kinds;
										i.chatModel = "03";
										i.chatRecords = "";
										i.chatOrder = n + 1;
										i.skuCode = this.skuList.value, //sku编号
											i.displayName = this.skuList.label //当sku作为属性值出现时的显示名称
									});
									console.log(this.info.arr9);
									this.$http
										.post(
											"/api/plant/knowledgeBase/insertChatScript",
											this.info.arr9
										)
										.then((res) => {
											console.log(res);
											if (res.data.status == 0) {
												this.$message.success("添加成功");
												this.dialogVisible = false;
												this.getList(kinds);
												this.getInfo()
												this.chooseType = kinds;
											} else {
												this.$message.error(res.data.msg);
											}
										});
								} else {
									this.info.arr9.forEach((i, n) => {
										i.kinds = kinds;
										i.chatModel = "03";
										i.chatRecords = "";
										i.chatOrder = n + 1;
										i.id = this.info.id
										i.chatRecords = this.info.chatRecords;
										i.skuCode = this.skuList.value, //sku编号
											i.displayName = this.skuList.label //当sku作为属性值出现时的显示名称
									});
									console.log(this.info.arr9);
									let obj = {
										kinds: kinds,
										parentId: this.$route.query.id, //关联ID
										chatModel: "03",
										chatScriptAoList: this.info.arr9
									}

									this.$http
										.post(
											"/api/plant/knowledgeBase/updateChatScript",
											obj
										)
										.then((res) => {
											console.log(res);
											if (res.data.status == 0) {
												this.$message.success("修改成功");
												this.dialogVisible = false;
												this.getList(kinds);
												this.getInfo()
												this.chooseType = kinds;
											} else {
												this.$message.error(res.data.data);
											}
										});
								}
								break;
							}
						}
						//添加文字素材
						if (paragraphType) {
							// return false
							if (this.title == "请输入发布信息") {
								this.$http.post("/api/plant/knowledgeBase/insertParagraph", {
									parentId: this.$route.query.id, //关联ID
									title: title, //内容标题
									paragraphType: paragraphType, //文本类型 01:内容段落02:富文本03:圈文
									paragraphUrl: url, //视频 图片url json
									paragraph: paragraph, //内容段落
									kinds: kinds,
									paragraphModel: "03", //01:节日素材
									skuCode: this.skuList.value, //sku编号
									displayName: this.skuList.label //当sku作为属性值出现时的显示名称
								}).then((res) => {
									if (res.data.status == 0) {
										this.$message.success("添加成功");
										this.dialogVisible = false;
										this.activeIndex = kinds;
										this.getList(kinds);
										this.getInfo()
									} else {
										this.$message.error(res.data.msg);
									}
								});
							} else {
								this.$http
									.post("/api/plant/knowledgeBase/updateParagraph", {
										id: this.info.id,
										parentId: this.$route.query.id, //关联ID
										title: title, //内容标题
										paragraphType: paragraphType, //文本类型 01:内容段落02:富文本03:圈文
										paragraphUrl: url, //视频 图片url json
										paragraph: paragraph, //内容段落
										kinds: kinds,
										paragraphModel: "03", //01:节日素材
										skuCode: this.skuList.value, //sku编号
										displayName: this.skuList.label //当sku作为属性值出现时的显示名称
									})
									.then((res) => {
										if (res.data.status == 0) {
											this.$message.success("修改成功");
											this.dialogVisible = false;
											this.activeIndex = kinds;
											this.getList(kinds);
											this.getInfo()
										} else {
											this.$message.error(res.data.msg);
										}
									});
							}
						}

						//添加图片素材
						if (materialType) {
							console.log(url);
							console.log(materialType);
							console.log(kinds);
							// return false
							if (this.title == "请输入发布信息") {
								this.$http
									.post("/api/plant/knowledgeBase/insertMaterialPic", [{
										parentId: this.$route.query.id - 0,
										url: url,
										materialType: materialType,
										kinds: kinds,
										description: this.info.description,
										picModel: "03",
										skuCode: this.skuList.value, //sku编号
										displayName: this.skuList.label //当sku作为属性值出现时的显示名称
									}, ])
									.then((res) => {
										console.log(res.data);
										if (res.data.status == 0) {
											this.$message.success("添加成功");
											this.dialogVisible = false;
											this.activeIndex = kinds;
											this.getList(kinds);
											this.getInfo()
										} else {
											this.$message.error(res.data.msg);
										}
									});
							} else {
								this.$http
									.post("/api/plant/knowledgeBase/updateMaterialPic", {
										id: this.info.id,
										parentId: this.$route.query.id - 0,
										url: url,
										materialType: materialType,
										description: this.info.description,
										kinds: kinds,
										picModel: "03",
										skuCode: this.skuList.value, //sku编号
										displayName: this.skuList.label //当sku作为属性值出现时的显示名称
									})
									.then((res) => {
										console.log(res.data);
										if (res.data.status == 0) {
											this.$message.success("修改成功");
											this.dialogVisible = false;
											this.activeIndex = kinds;
											this.getList(kinds);
											this.getInfo()
										} else {
											this.$message.error(res.data.msg);
										}
									});
							}
						}
					}
				});
			},
			//添加内容
			addCon(num) {
				switch (num) {
					case 6: {
						this.info.arr7.push({
							paragraph7: "",
						});
					}
					case 4: {
						this.info.arr4.push({
							commodityPic: [],
							commodityTitle: "",
							commodityPrices: null,
							commodityId: "",
						});
					}
				}
			},
			delCon(index, num) {
				switch (num) {
					case 6: {
						this.info.arr7.splice(index, 1);
					}
					case 4: {
						this.info.arr4.splice(index, 1);
					}
					case "4s": {
						this.info.arr4[index].commodityPic.splice(index, 1);
					}
				}
			},
			add(num) {
				switch (num) {
					case 1: {
						console.log(typeof this.info.arr9);
						this.info.arr9.push({
							chatType: "01",
							chatContent: "",
						});
						break;
					}
					case 2: {
						this.info.arr9.push({
							chatType: "02",
							chatContent: "",
						});
						break;
					}
				}
				console.log(this.info.arr9);
			},
			del(item, index) {
				console.log(item, index);
				this.info.arr9.splice(index, 1);
			},
			//添加
			addList() {
				this.skuList = {}
				this.title = "请输入发布信息";
				this.dialogVisible = true;
				this.hideUpload = false;
				this.info = {
					id: "",
					chatRecords: "",
					url1: "",
					video2: "",
					url6: "",
					title3: "",
					url3: "",
					video3: "",
					title8: "",
					title7: "",
					arr7: [{
						paragraph7: "",
					}, ],
					arr4: [{
						commodityPic: [],
						commodityTitle: "",
						commodityPrices: null,
						commodityId: "",
					}, ],
					arr9: [],
				};
				this.fileList = []
				this.chooseType = 2;
			},
			//编辑
			editorList(item) {
				console.log(item);
				this.skuList = {
					label: item.displayName,
					value: item.skuCode,
				}
				this.info.id = item.id;
				this.title = "编辑发布信息";
				this.fileList = []
				this.hideUpload = false
				this.dialogVisible = true;
				switch (item.materialType) {
					case "03": {
						console.log(1);
						this.chooseType = 1;
						this.fileList = [];
						this.hideUpload = true;
						this.fileList.push({
							url: item.url,
						});
						this.info.url1 = item.url
						this.info.description = item.description
						break;
					}
					case "04": {
						console.log(2);
						this.chooseType = 2;
						this.hideUpload = true;
						this.info.video2 = item.url;

						break;
					}
					case "02": {
						this.chooseType = 6;
						this.fileList = [];
						this.info.url6 = item.url;
						this.fileList = item.imgUrl
						if (this.fileList.length >= 9) {
							this.hideUpload = true;
						}

						break;
					}
				}
				switch (item.paragraphType) {
					case "01": {
						this.chooseType = 7;
						this.info.title7 = item.paragraph;
						this.info.arr7 = [];
						item.paragraph2.forEach((i) => {
							this.info.arr7.push({
								paragraph7: i,
							});
						});
						console.log(this.info.arr7);

						break;
					}
					case "02": {
						this.chooseType = 8;
						this.info.title8 = item.paragraph;

						break;
					}
					case "03": {
						this.chooseType = 3;
						this.fileList = [];
						if (item.type2 == 0) {
							this.fileList = item.imgUrl;
							this.value = 0;
							if (this.fileList.length >= 9) {
								this.hideUpload = true;
							}
						} else {
							this.value = 1;
							this.info.video3 = item.paragraphUrl;
						}
						this.info.title3 = item.paragraph;

						break;
					}
				}
				if (item.commodityId) {
					this.chooseType = 4;
					this.info.arr4 = [{
						commodityId: item.commodityId,
						commodityPic: [{
							url: item.commodityPic,
						}, ],
						commodityPrices: item.commodityPrices,
						commodityTitle: item.commodityTitle,
					}, ];
					this.isShow2 = false

				}
				if (item.length > 0) {
					this.chooseType = 9;
					this.info.chatRecords = item[0].chatRecords;
					this.skuList = {
						label: item[0].displayName,
						value: item[0].skuCode,
					}
					this.info.arr9 = [];
					item.forEach((i) => {
						this.info.arr9.push({
							chatContent: i.chatContent,
							chatType: i.chatType,
							id: i.id,
						});
					});

				}
			},
			//删除
			delList(item) {
				console.log(item);
				let id = "";
				let type = "";
				let arr = [];
				id = item.id;
				this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					let url = "";
					if (item.materialType) {
						url = "updateMaterialPic";
						type = 1;
					}
					if (item.paragraphType) {
						url = "updateParagraph";
						type = 1;
					}
					if (item.commodityId) {
						url = "updateFestCommodity";
						type = 1;
					}
					if (item.length > 0) {
						if (item[0].chatOrder) {
							url = "updateChatScript";
							type = 2;

						}
					}
					console.log(arr);
					console.log(type);
					if (type == 1) {
						this.$http
							.post("/api/plant/knowledgeBase/" + url, {
								id: id,
								deleteStatus: 1,
							})
							.then((res) => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success("删除成功");
									this.dialogVisible = false;
									this.getList(this.activeIndex);
								} else {
									this.$message.error(res.data.msg);
								}
							});
					} else {
						console.log(item);
						this.$http
							.post("/api/plant/knowledgeBase/" + url, {
								parentId: this.$route.query.id,
								chatModel: "03",
								kinds: item[0].kinds,
								chatScriptAoList: []
							})
							.then((res) => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success("删除成功");
									this.dialogVisible = false;
									this.getList(this.activeIndex);
								} else {
									this.$message.error(res.data.msg);
								}
							});
					}
				});
			},
			//选择类型
			choose(item) {
				console.log(item);
				this.fileList = []
				this.hideUpload = false
				this.chooseType = item.value;
				if (this.chooseType != 1) {
					this.info.url1 = "";
				}
				if (this.chooseType != 2) {
					this.info.video2 = "";
				}
				if (this.chooseType != 3) {
					this.info.video2 = "";
				}
				if (this.chooseType != 4) {
					this.info.arr4 = [{
						commodityPic: [],
						commodityTitle: "",
						commodityPrices: null,
						commodityId: "",
					}, ];
				}
				if (this.chooseType != 6) {
					this.info.url6 = "";
				}
				if (this.chooseType != 7) {
					this.info.title7 = "";
					this.info.arr7 = [{
						title: "",
					}];
				}
				if (this.chooseType != 8) {
					this.info.title8 = "";
				}
				if (this.chooseType != 9) {
					this.info.arr9 = [];
				}
			},
			//选择圈文的上传类型
			chooseValue() {
				this.fileList = []
				if (this.value == 0) {
					this.info.video3 = "";
				} else {
					this.info.url3 = "";
				}
				this.hideUpload = false
				console.log(this.info.video3, this.hideUpload);
			},
			//上传图片
			getPictrueURL(res, file, fileList) {
				switch (this.chooseType) {
					case 1: {
						console.log(res);
						this.info.url1 = res.data;
						this.hideUpload = fileList.length >= 1;
						break;
					}
					case 2: {
						console.log(res);
						this.info.video2 = res.data;
						console.log(this.info.video2);
						break;
					}

					case 3: {
						switch (this.value) {
							case 0: {
								if (this.info.url3[this.info.url3.length - 1] == "") {
									this.info.url3 = res.data;
								} else {
									if (this.info.url3.length > 0) {
										this.info.url3 += "," + res.data;
									} else {
										this.info.url3 = res.data;
									}
								}
								this.hideUpload = fileList.length >= 9;
								break;
							}
							case 1: {
								this.info.video3 = res.data;
								break;
							}
						}
						break;
					}

					case 6: {
						if (this.info.url6[this.info.url6.length - 1] == "") {
							this.info.url6 = res.data;
						} else {
							if (this.info.url6.length > 0) {
								this.info.url6 += "," + res.data;
							} else {
								this.info.url6 = res.data;
							}
						}
						this.hideUpload = fileList.length >= 9;
						break;
					}
				}
			},
			//预览图片
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},
			// 图片删除
			handleRemove(file, fileList) {
				switch (this.chooseType) {
					case 1: {
						console.log(1);
						this.info.url1 = ''
						this.fileList = []
						this.hideUpload = false;
						break;
					}
					case 2: {
						console.log(1);
						this.info.video2 = "";
						break;
					}

					case 3: {
						switch (this.value) {
							case 0: {
								let files = this.info.url3.split(",");
								console.log(files);
								files.splice(files.indexOf(file.url), 1);
								this.info.url3 = files.length === 0 ? "" : files.join(",");
								this.fileList = fileList
								this.hideUpload = fileList.length >= 9;
								break;
							}
							case 1: {
								this.info.video3 = "";
								this.hideUpload = fileList.length >= 1;
								break;
							}
						}
						break;
					}

					case 6: {
						let files = this.info.url6.split(",");
						console.log(files);
						files.splice(files.indexOf(file.url), 1);
						this.info.url6 = files.length === 0 ? "" : files.join(",");
						this.hideUpload = fileList.length >= 9;
						break;
					}
				}
			},
			// 图片预览dialog关闭时的回调
			imagePrevClosed() {
				this.dialogImageUrl = "";
			},
			getPictrueURL2(obj, res, file, fileList) {
				var index = obj.index;
				this.info.arr4[index].commodityPic.push({
					url: res.data,
				});
				console.log(this.info.arr4);
			},
			handleRemove2(obj, file, fileList) {
				let index = obj.index;
				this.info.arr4[index].commodityPic = [];
				this.hideUpload = false;
			},
			getList(kinds) {
				this.$http
					.post("/api/plant/knowledgeBase/selectMaterialByKind", {
						id: this.$route.query.id,
						kinds: kinds,
						model: '03'
					})
					.then((res) => {
						// console.log(res.data.data);
						var arr = res.data.data.chatScriptVos;
						var map = {},
							dest = [];
						for (var i = 0; i < arr.length; i++) {
							var ai = arr[i];
							if (!map[ai.chatRecords]) {
								dest.push({
									chatRecords: ai.chatRecords,
									data: [ai]
								});
								map[ai.chatRecords] = ai;
							} else {
								for (var j = 0; j < dest.length; j++) {
									var dj = dest[j];
									if (dj.chatRecords == ai.chatRecords) {
										dj.data.push(ai);
										break;
									}
								}
							}
						}
						console.log(dest);
						this.chatScriptVos = []
						dest.forEach(i => {
							this.chatScriptVos.push(i.data)
						})
						console.log('聊天话术', this.chatScriptVos);
						let festivalCommodityVos = res.data.data.festivalCommodityVos
						if (festivalCommodityVos.length > 0) {
							festivalCommodityVos.forEach(i => {

							})
						}
						this.festivalCommodityVos = festivalCommodityVos
						// console.log("节日款商品", this.festivalCommodityVos);
						let materialPicVos = res.data.data.materialPicVos
						if (materialPicVos.length > 0) {
							materialPicVos.forEach(i => {
								let imgUrl = []
								if (i.materialType == "02") {
									imgUrl = i.url.split(',')
									i.imgUrl = []
									if (imgUrl.length > 0) {
										imgUrl.forEach(item => {
											i.imgUrl.push({
												url: item
											})
										})
									}
								}

							})
						}
						this.materialPicVos = materialPicVos
						// console.log('海报，视频，商品主图', this.materialPicVos);
						let paragraphVos = res.data.data.paragraphVos
						if (paragraphVos.length > 0) {
							paragraphVos.forEach(i => {
								if (i.paragraphType == "01") {
									i.paragraph2 = [];
									i.paragraph2 = i.paragraph.split("&");
								}
								if (i.paragraphType == "03") {
									i.type2 = ''
									if (i.paragraphUrl.substring(i.paragraphUrl.length - 4) ==
										".mp4") {
										i.type2 = 1
									} else {
										i.type2 = 0
										i.imgUrl = [];
										i.paragraphUrl.split(",").forEach((item) => {
											i.imgUrl.push({
												url: item,
											});
										});
									}
								}
							})
						}
						this.paragraphVos = paragraphVos
						// console.log('圈文，富文本，段落', this.paragraphVos);
					});
			},
			getInfo() {
				this.$http.post('/api/plant/knowledgeBase/selectCategoryStyle', {
					"id": this.$route.query.id,
					"pageNum": 1,
					"pageSize": 1
				}).then(res => {
					let list = res.data.data.list[0]
					console.log(list.labelVos);
					let name = []
					if (list.labelVos) {
						list.labelVos.forEach(i => {
							name.push(i.labelName)
						})
					}
					this.info2 = {
						primaryName: list.primaryName,
						secondaryName: list.secondaryName,
						commodityName: list.commodityName,
						commodityId: list.commodityId,
						commodityPic: list.commodityPic,
						labelName: name.join(',')
					}
					this.$http.post('/api/plant/knowledgeBase/selectSkuByProductId', {
						"productId": list.commodityId
					}).then(res => {
						console.log('sku', res.data.data);
						this.Skuoptions = []
						if (res.data.data.length > 0) {
							res.data.data.forEach(item => {
								this.Skuoptions.push({
									value: item.skuCode,
									label: item.displayName
								})
							})
						}

					})
				})
			}
		},
		created() {
			this.getInfo()
			if (this.$route.query.kinds) {
				let kinds = this.$route.query.kinds;
				this.getList(kinds);
				this.getInfo()
				this.activeIndex = kinds;
			} else {
				this.getList("07");
				this.getInfo()
			}
		}
	}
</script>

<style scoped>
	.add {
		position: fixed;
		right: 100px;
		top: 300px;
		width: 100px;
		height: 100px;
	}

	.el-form-item {
		margin-bottom: 10px;
	}

	.tag {
		width: 100px;
		background-color: #fff;
		margin-left: 10px;
		text-align: center;
		color: #000;
		border: 1px solid #000;
	}

	.tag2 {
		width: 100px;
		background-color: #209cd3;
		margin-left: 10px;
		text-align: center;
		color: #fff;
		border: 1px solid #209cd3;
	}

	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>
